import { render, staticRenderFns } from "./Job.vue?vue&type=template&id=32b0f22a&"
import script from "./Job.js?vue&type=script&lang=js&"
export * from "./Job.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports